/**
 * @description 使用滤镜实现任意颜色的转换
 */
export  function  rgbToHslV4(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    let max = Math.max(r, g, b);
    let min = Math.min(r, g, b);
    let delta = max - min;
    let h;
    let s;
    let l;

    if(max === min) {
        h = 0;
    } else if(r === max) {
        h = (g - b) / delta;
    } else if(g === max) {
        h = 2 + (b - r) / delta;
    } else if(b === max) {
        h = 4 + (r - g) / delta;
    }

    h = Math.min(h * 60, 360);

    if(h < 0) {
        h += 360;
    }

    l = (min + max) / 2;

    if(max === min) {
        s = 0;
    } else if(l <= 0.5) {
        s = delta / (max + min);
    } else {
        s = delta / (2 - max - min);
    }

    return([h, s * 100, l * 100]);
}
String.prototype.colorHex = function() {
    var h = this;
    var f = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
    if (/^(rgb|RGB)/.test(h)) {
        var b = h.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
        var a = "#";
        for (var c = 0; c < b.length; c++) {
            var g = Number(b[c]).toString(16);
            if (g.length < 2) {
                g = "0" + g
            }
            a += g
        }
        if (a.length !== 7) {
            a = h
        }
        return a
    } else {
        if (f.test(h)) {
            var e = h.replace(/#/, "").split("");
            if (e.length === 6) {
                return h
            } else {
                if (e.length === 3) {
                    var d = "#";
                    for (var c = 0; c < e.length; c += 1) {
                        d += (e[c] + e[c])
                    }
                    return d
                }
            }
        }
    }
    return h
}
;
function rgbToHsv(a, i, j) {
    a = a / 255;
    i = i / 255;
    j = j / 255;
    var f, n, m;
    var e = Math.min(a, i, j);
    var k = m = Math.max(a, i, j);
    var d = (e + k) / 2;
    var c = k - e;
    if (k == e) {
        f = 0
    } else {
        switch (k) {
            case a:
                f = (i - j) / c + (i < j ? 6 : 0);
                break;
            case i:
                f = 2 + (j - a) / c;
                break;
            case j:
                f = 4 + (a - i) / c;
                break
        }
        f = Math.round(f * 60)
    }
    if (k == 0) {
        n = 0
    } else {
        n = 1 - e / k
    }
    n = Math.round(n * 100);
    m = Math.round(m * 100);
    return [f, n, m]
}
"use strict";
var _createClass = function() {
    function a(e, c) {
        for (var b = 0; b < c.length; b++) {
            var d = c[b];
            d.enumerable = d.enumerable || false;
            d.configurable = true;
            if ("value"in d) {
                d.writable = true
            }
            Object.defineProperty(e, d.key, d)
        }
    }
    return function(d, b, c) {
        if (b) {
            a(d.prototype, b)
        }
        if (c) {
            a(d, c)
        }
        return d
    }
}();
function _classCallCheck(a, b) {
    if (!(a instanceof b)) {
        throw new TypeError("Cannot call a class as a function")
    }
}
var Color = function() {
    function b(q, p, o) {
        _classCallCheck(this, b);
        this.set(q, p, o)
    }
    _createClass(b, [{
        key: "toString",
        value: function f() {
            return "rgb(" + Math.round(this.r) + ", " + Math.round(this.g) + ", " + Math.round(this.b) + ")"
        }
    }, {
        key: "set",
        value: function m(q, p, o) {
            this.r = this.clamp(q);
            this.g = this.clamp(p);
            this.b = this.clamp(o)
        }
    }, {
        key: "hueRotate",
        value: function i() {
            var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            q = q / 180 * Math.PI;
            var o = Math.sin(q);
            var p = Math.cos(q);
            this.multiply([0.213 + p * 0.787 - o * 0.213, 0.715 - p * 0.715 - o * 0.715, 0.072 - p * 0.072 + o * 0.928, 0.213 - p * 0.213 + o * 0.143, 0.715 + p * 0.285 + o * 0.14, 0.072 - p * 0.072 - o * 0.283, 0.213 - p * 0.213 - o * 0.787, 0.715 - p * 0.715 + o * 0.715, 0.072 + p * 0.928 + o * 0.072])
        }
    }, {
        key: "grayscale",
        value: function c() {
            var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            this.multiply([0.2126 + 0.7874 * (1 - o), 0.7152 - 0.7152 * (1 - o), 0.0722 - 0.0722 * (1 - o), 0.2126 - 0.2126 * (1 - o), 0.7152 + 0.2848 * (1 - o), 0.0722 - 0.0722 * (1 - o), 0.2126 - 0.2126 * (1 - o), 0.7152 - 0.7152 * (1 - o), 0.0722 + 0.9278 * (1 - o)])
        }
    }, {
        key: "sepia",
        value: function g() {
            var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            this.multiply([0.393 + 0.607 * (1 - o), 0.769 - 0.769 * (1 - o), 0.189 - 0.189 * (1 - o), 0.349 - 0.349 * (1 - o), 0.686 + 0.314 * (1 - o), 0.168 - 0.168 * (1 - o), 0.272 - 0.272 * (1 - o), 0.534 - 0.534 * (1 - o), 0.131 + 0.869 * (1 - o)])
        }
    }, {
        key: "saturate",
        value: function e() {
            var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            this.multiply([0.213 + 0.787 * o, 0.715 - 0.715 * o, 0.072 - 0.072 * o, 0.213 - 0.213 * o, 0.715 + 0.285 * o, 0.072 - 0.072 * o, 0.213 - 0.213 * o, 0.715 - 0.715 * o, 0.072 + 0.928 * o])
        }
    }, {
        key: "multiply",
        value: function d(o) {
            var q = this.clamp(this.r * o[0] + this.g * o[1] + this.b * o[2]);
            var p = this.clamp(this.r * o[3] + this.g * o[4] + this.b * o[5]);
            var r = this.clamp(this.r * o[6] + this.g * o[7] + this.b * o[8]);
            this.r = q;
            this.g = p;
            this.b = r
        }
    }, {
        key: "brightness",
        value: function l() {
            var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            this.linear(o)
        }
    }, {
        key: "contrast",
        value: function h() {
            var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            this.linear(o, -(0.5 * o) + 0.5)
        }
    }, {
        key: "linear",
        value: function k() {
            var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            this.r = this.clamp(this.r * o + p * 255);
            this.g = this.clamp(this.g * o + p * 255);
            this.b = this.clamp(this.b * o + p * 255)
        }
    }, {
        key: "invert",
        value: function a() {
            var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            this.r = this.clamp((o + this.r / 255 * (1 - 2 * o)) * 255);
            this.g = this.clamp((o + this.g / 255 * (1 - 2 * o)) * 255);
            this.b = this.clamp((o + this.b / 255 * (1 - 2 * o)) * 255)
        }
    }, {
        key: "hsl",
        value: function n() {
            var o = this.r / 255;
            var u = this.g / 255;
            var w = this.b / 255;
            var x = Math.max(o, u, w);
            var q = Math.min(o, u, w);
            var t = void 0
                , y = void 0
                , p = (x + q) / 2;
            if (x === q) {
                t = y = 0
            } else {
                var v = x - q;
                y = p > 0.5 ? v / (2 - x - q) : v / (x + q);
                switch (x) {
                    case o:
                        t = (u - w) / v + (u < w ? 6 : 0);
                        break;
                    case u:
                        t = (w - o) / v + 2;
                        break;
                    case w:
                        t = (o - u) / v + 4;
                        break
                }
                t /= 6
            }
            return {
                h: t * 100,
                s: y * 100,
                l: p * 100
            }
        }
    }, {
        key: "clamp",
        value: function j(o) {
            if (o > 255) {
                o = 255
            } else {
                if (o < 0) {
                    o = 0
                }
            }
            return o
        }
    }]);
    return b
}();
var Solver = function() {
    function e(h, i) {
        _classCallCheck(this, e);
        this.target = h;
        this.targetHSL = h.hsl();
        this.reusedColor = new Color(0,0,0)
    }
    _createClass(e, [{
        key: "solve",
        value: function c() {
            var h = this.solveNarrow(this.solveWide());
            return {
                values: h.values,
                loss: h.loss,
                filter: this.css(h.values)
            }
        }
    }, {
        key: "solveWide",
        value: function b() {
            var j = 5;
            var o = 15;
            var k = [60, 180, 18000, 600, 1.2, 1.2];
            var n = {
                loss: Infinity
            };
            for (var m = 0; n.loss > 25 && m < 3; m++) {
                var l = [50, 20, 3750, 50, 100, 100];
                var h = this.spsa(j, k, o, l, 1000);
                if (h.loss < n.loss) {
                    n = h
                }
            }
            return n
        }
    }, {
        key: "solveNarrow",
        value: function g(k) {
            var h = k.loss;
            var l = 2;
            var j = h + 1;
            var i = [0.25 * j, 0.25 * j, j, 0.25 * j, 0.2 * j, 0.2 * j];
            return this.spsa(h, i, l, k.values, 500)
        }
    }, {
        key: "spsa",
        value: function f(w, E, C, j, q) {
            var o = 1;
            var r = 0.16666666666666666;
            var m = null;
            var h = Infinity;
            var s = new Array(6);
            var p = new Array(6);
            var D = new Array(6);
            for (var x = 0; x < q; x++) {
                var t = C / Math.pow(x + 1, r);
                for (var z = 0; z < 6; z++) {
                    s[z] = Math.random() > 0.5 ? 1 : -1;
                    p[z] = j[z] + t * s[z];
                    D[z] = j[z] - t * s[z]
                }
                var u = this.loss(p) - this.loss(D);
                for (var l = 0; l < 6; l++) {
                    var B = u / (2 * t) * s[l];
                    var y = E[l] / Math.pow(w + x + 1, o);
                    j[l] = v(j[l] - y * B, l)
                }
                var n = this.loss(j);
                if (n < h) {
                    m = j.slice(0);
                    h = n
                }
            }
            return {
                values: m,
                loss: h
            };
            function v(A, k) {
                var i = 100;
                if (k === 2) {
                    i = 7500
                } else {
                    if (k === 4 || k === 5) {
                        i = 200
                    }
                }
                if (k === 3) {
                    if (A > i) {
                        A %= i
                    } else {
                        if (A < 0) {
                            A = i + A % i
                        }
                    }
                } else {
                    if (A < 0) {
                        A = 0
                    } else {
                        if (A > i) {
                            A = i
                        }
                    }
                }
                return A
            }
        }
    }, {
        key: "loss",
        value: function d(i) {
            var h = this.reusedColor;
            h.set(0, 0, 0);
            h.invert(i[0] / 100);
            h.sepia(i[1] / 100);
            h.saturate(i[2] / 100);
            h.hueRotate(i[3] * 3.6);
            h.brightness(i[4] / 100);
            h.contrast(i[5] / 100);
            var j = h.hsl();
            return Math.abs(h.r - this.target.r) + Math.abs(h.g - this.target.g) + Math.abs(h.b - this.target.b) + Math.abs(j.h - this.targetHSL.h) + Math.abs(j.s - this.targetHSL.s) + Math.abs(j.l - this.targetHSL.l)
        }
    }, {
        key: "css",
        value: function a(i) {
            function h(j) {
                var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
                return Math.round(i[j] * k)
            }
            return "filter: invert(" + h(0) + "%) sepia(" + h(1) + "%) saturate(" + h(2) + "%) hue-rotate(" + h(3, 3.6) + "deg) brightness(" + h(4) + "%) contrast(" + h(5) + "%);"
        }
    }]);
    return e
}();
function hexToRgb(c) {
    var b = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    c = c.replace(b, function(e, h, f, d) {
        return h + h + f + f + d + d
    });
    var a = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(c);
    return a ? [parseInt(a[1], 16), parseInt(a[2], 16), parseInt(a[3], 16)] : null
}
export function getColorFilter(from,to){
    var n = new Color(to[0],to[1],to[2]);
    var t = new Solver(n);
    t.reusedColor = new Color(from[0],from[1],from[2]);
    var f = t.solve();
    return f;
}

